import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common";
import { CashRequestPanel } from "@/components/CashRequestPanel";
import { PaymentsInbox } from "@/components/PaymentsInbox";

// Customer: submit + own request history.
// Reseller: own requests to Admin + an approval inbox for their customers' requests.
export default function AccountPayments() {
  const { user } = useAuth();
  const isReseller = user?.role === "reseller";

  return (
    <div className="space-y-10" data-testid="account-payments-page">
      <div className="space-y-4">
        <PageHeader
          title={isReseller ? "Payments — My Requests" : "Payments"}
          subtitle={isReseller
            ? "Your own cash top-up requests are approved by the platform admin."
            : "Submit a cash top-up request. Your balance updates only after it is approved."} />
        <CashRequestPanel />
      </div>

      {isReseller && (
        <div className="space-y-4">
          <PageHeader title="Payments — Customer Requests"
            subtitle="Incoming cash requests from your customers. Approving credits their balance." />
          <PaymentsInbox />
        </div>
      )}
    </div>
  );
}
